/* -disable array-callback-return */
/* -disable react/forbid-prop-types */
/* -disable react/require-default-props */
import React, { Component } from 'react';
import { connect } from 'react-redux';

// Components
import Panel from '../Panel';
import NewTable from './NewTable';
import LoadingIndicator from '../../../../components/LoadingIndicator';
import AlertMessage from '../../../../components/AlertMessage';
import { CheckboxStatus } from './CheckboxStatus';

// CSS
import './styles.css';

// Thunks + Action Creators
import {
  getDeliveryStatusDeliveriesList,
  deliveryStatusTypes,
} from '../../../../redux/delivery-status';

// Consts
import {
  getPerformanceStatusLabel,
  performanceStatus,
} from '../../../Tracking/utils/delivery-status';

// Selectors
import {
  getDeliveryStatusDeliveriesByAccType,
  getDeliveryStatusCounters,
  getDeliveryStatusUI,
} from '../../../../redux/selectors';


class DeliveryStatus extends Component {
  constructor(props) {
    super(props);

    this.state = {
      headers: [
        { title: 'NF', width: '20%' },
        {
          title: 'Valor (R$)',
          width: '53.5%',
          alignment: 'right',
          format: 'currency',
        },
        { title: 'Cliente' },
      ],
      activeTab: [
        performanceStatus.ONTIME,
        performanceStatus.LATE_RISK,
        performanceStatus.LATE
      ],
    };
  }

  _onRetry = () => {
    const { shouldUsePeriodSelectDates, notPassCompanyId } = this.props;

    this.props.dispatch(
      getDeliveryStatusDeliveriesList(
        shouldUsePeriodSelectDates,
        'periodSelection',
        notPassCompanyId,
      ),
    );
  };

  _setActiveTab(tabPerformanceStatusCode) {
    const { onTabChange } = this.props;

    this.setState({
      activeTab: tabPerformanceStatusCode,
    });

    if (onTabChange) onTabChange(this.props.type, tabPerformanceStatusCode);
  }

  _filterNfListObject = nfListObj => {
    const { onTimePosition, lateRiskPosition, latePosition } = this.props;
    const allDeliveries = [
      ...onTimePosition,
      ...lateRiskPosition,
      ...latePosition,
    ];

    const order = {
      [performanceStatus.ONTIME]: 0,
      [performanceStatus.LATE_RISK]: 1,
      [performanceStatus.LATE]: 2
    };

    return nfListObj.map(nfObj => {
      let hasAppPosition = false;
      let hasTrackerPosition = false;

      allDeliveries.map(el => {
        if (el.nfId === nfObj.id) {
          if (el.appLocation !== null) {
            hasAppPosition = true;
          }
          if (el.trackerLocation !== null) {
            hasTrackerPosition = true;
          }
        }
      });

      return {
        id: Number(nfObj.id),
        nf: `${nfObj.nf}-${nfObj.nfGroup}`,
        nfValue: nfObj.nfValue,
        client: nfObj.destination.name,
        truckTracker: nfObj.tms.truckTracker,
        hasTrackerPosition,
        hasAppPosition,
        status: nfObj.performance
      };
    }).sort((a, b) => order[a.status] - order[b.status]);
  };

  _getNfListByPerformanceStatusCode = tabPerformanceStatusCode => {
    const {onTime, lateRisk, late} = this.props;

    const statusDataMap = {
      [performanceStatus.ONTIME]: onTime,
      [performanceStatus.LATE_RISK]: lateRisk,
      [performanceStatus.LATE]: late,
    };

    const flatedData = tabPerformanceStatusCode.flatMap(status => {
      const data = statusDataMap[status] || [];
      return data.map(item => ({
        ...item,
        status
      }));
    });

    return this._filterNfListObject(flatedData);
  };

  render() {
    const {
      label,
      counters,
      ui,
      isModalOpen,
      onGetNfLocationFromTable,
      activeRow,
    } = this.props;

    const { activeTab } = this.state;

    const handleChange = (e, value) => {
      if (!e.target.checked) {
        this._setActiveTab(
          activeTab.filter(item => Number(item) !== Number(value))
        )
      } else {
        this._setActiveTab([...activeTab, value]);
      }
    };

    return (
      <Panel
        collapsible={this.props.collapsible}
        className="DeliveryStatus"
        title="Status de entrega"
        label={label}
      >
        {ui.isFetching && (
          <div className="DeliveryStatus__LoadingIndicator">
            <LoadingIndicator text="Carregando..." theme="dark" noScrollLock />
          </div>
        )}
        {ui.error && !ui.isFetching && (
          <div className="DeliveryStatus__error-message">
            <AlertMessage
              error
              message="Ocorreu um erro"
              actionText="Tente novamente"
              onRetry={() => this._onRetry()}
            />
          </div>
        )}
        {!ui.isFetching && !ui.error && (
          <div>
            <div className="DeliveryStatus__radio-group-status">
              <CheckboxStatus
                label={getPerformanceStatusLabel(performanceStatus.ONTIME)}
                percent={counters.ontimeTotalPercent}
                count={counters.ontimeTotalCount}
                onChange={e => handleChange(e, performanceStatus.ONTIME)}
                value={performanceStatus.ONTIME}
                defaultChecked={activeTab.some(item => item === performanceStatus.LATE_RISK)}
                color="#2E7D32"
              />
              <CheckboxStatus
                label={getPerformanceStatusLabel(performanceStatus.LATE_RISK)}
                percent={counters.lateRiskTotalPercent}
                count={counters.lateRiskTotalCount}
                onChange={e => handleChange(e, performanceStatus.LATE_RISK)}
                value={performanceStatus.LATE_RISK}
                defaultChecked={activeTab.some(item => item === performanceStatus.LATE_RISK)}
                color="#E65100"
              />
              <CheckboxStatus
                label={getPerformanceStatusLabel(performanceStatus.LATE)}
                percent={counters.lateTotalPercent}
                count={counters.lateTotalCount}
                onChange={e => handleChange(e, performanceStatus.LATE)}
                value={performanceStatus.LATE}
                defaultChecked={activeTab.some(item => item === performanceStatus.LATE_RISK)}
                color="#D32F2F"
              />
            </div>
            <div className="DeliveryStatus__table-container">
              <NewTable
                headers={this.state.headers}
                className="DeliveryStatus__table-list"
                data={this._getNfListByPerformanceStatusCode(activeTab)}
                isFetching={ui.isFetching}
                hasError={ui.error}
                onRetry={() => {}}
                hasHover
                onRowClick={onGetNfLocationFromTable}
                activeRow={activeRow}
                isActive={isModalOpen}
              />
            </div>
          </div>
        )}
      </Panel>
    );
  }
}

function mapStateToProps(state, ownProps) {
  let isKeyAcc = null;
  const { storeKey } = ownProps;

  if (ownProps.type === deliveryStatusTypes.PRIME) isKeyAcc = true;
  if (ownProps.type === deliveryStatusTypes.NORMAL) isKeyAcc = false;

  return {
    ui: getDeliveryStatusUI(storeKey)(state),
    counters: getDeliveryStatusCounters(isKeyAcc, storeKey)(state),
    onTime: getDeliveryStatusDeliveriesByAccType(
      isKeyAcc,
      performanceStatus.ONTIME,
      storeKey,
    )(state),
    lateRisk: getDeliveryStatusDeliveriesByAccType(
      isKeyAcc,
      performanceStatus.LATE_RISK,
      storeKey,
    )(state),
    late: getDeliveryStatusDeliveriesByAccType(
      isKeyAcc,
      performanceStatus.LATE,
      storeKey,
    )(state),
    onTimePosition: state.dashboardRealTime.onTime.data,
    lateRiskPosition: state.dashboardRealTime.lateRisk.data,
    latePosition: state.dashboardRealTime.late.data,
  };
}

export default connect(mapStateToProps)(DeliveryStatus);
